export default "__VITE_ASSET__BkY_7Obh__"